import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// 競合分析: metric selector triggers a full-page reload (query-param redirect, no XHR),
// while per-account visibility checkboxes toggle the matching series on the live
// ApexCharts instance via the public ApexCharts.exec(chartId, "toggleSeries", name) API.
export default class extends Controller {
  static targets = ["chart"]
  static values = {
    basePath: String,
    from: String,
    to: String,
    metric: String,
    chartId: { type: String, default: "competitor-analysis-chart" }
  }

  // Metric button -> full-page navigation with ?metric=&fromDate=&toDate=
  selectMetric(e) {
    const metric = e.currentTarget.dataset.metric
    if (!metric || metric === this.metricValue) return
    const params = new URLSearchParams()
    params.set("metric", metric)
    if (this.fromValue) params.set("fromDate", this.fromValue)
    if (this.toValue) params.set("toDate", this.toValue)
    window.location.assign(`${this.basePathValue}?${params.toString()}`)
  }

  // Visibility checkbox -> toggle the series whose name we recover from the chart config
  // embedded on the apex-chart div (kept in sync with the server-rendered series order).
  toggleAccount(e) {
    const index = parseInt(e.currentTarget.dataset.seriesIndex, 10)
    if (Number.isNaN(index)) return
    const name = this.seriesName(index)
    if (!name) return
    try {
      if (e.currentTarget.checked) {
        ApexCharts.exec(this.chartIdValue, "showSeries", name)
      } else {
        ApexCharts.exec(this.chartIdValue, "hideSeries", name)
      }
    } catch (err) {
      console.error("[competitor-analysis] toggle error:", err)
    }
  }

  // Read the series name at `index` from the same JSON the apex-chart controller renders.
  seriesName(index) {
    if (!this.hasChartTarget) return null
    const raw = this.chartTarget.getAttribute("data-apex-chart-config-value")
    if (!raw) return null
    try {
      const cfg = JSON.parse(raw)
      const series = cfg.series || []
      return series[index] ? series[index].name : null
    } catch (_e) {
      return null
    }
  }
}
